import React from 'react';
import qs from 'query-string';
import Router, { useRouter } from 'next/router';
import NextLink from 'next/link';

export const Link = props => {
  const { href, className, children, ...linkProps } = props;

  return (
    <NextLink href={href} {...linkProps}>
      {children}
    </NextLink>
  );
};

export function withRouter(C) {
  return props => {
    const router = useRouter();
    const info = {
      match: {
        params: router.query,
      },
      location: {
        pathname: (router.asPath || '').split('?')[0],
        search: qs.stringify(router.query),
      },
      history: {
        push: router.push,
        replace: url => {
          if (url.startsWith('#')) {
            if (typeof window !== 'undefined') {
              window.location.hash = url;
            }
          } else {
            router.replace(url);
          }
        },
      },
    };

    return <C {...props} {...info} />;
  };
}

export const Route = props => {
  const router = useRouter();
  const exp = props.exact ? props.path : `${props.path}*`;
  const re = new RegExp(exp.replace('*', '.*'));
  const matches = re.test(router.asPath);

  if (props.children)
    return props.children({
      match: matches ? { url: router.asPath } : null,
    });

  if (matches) {
    if (props.render) return props.render();
  }

  return <></>;
};

export const Redirect = props => {
  const router = useRouter();

  if (typeof window === 'undefined') {
    return null;
  }

  if (props.replace) {
    router.replace(props.to);
  } else {
    router.push(props.to);
  }

  return null;
};

export function isomorphicRedirect(res, href, replace = false) {
  if (res) {
    res.writeHead(302, { Location: href });
    res.end();
  } else {
    if (replace) {
      Router.replace(href);
    } else {
      Router.push(href);
    }
  }
}
